import { Skeleton } from "@postdaily/ui/components/skeleton";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { OnboardingWizard } from "@/components/onboarding/onboarding-wizard";
import { useCurrentWorkspace } from "@/hooks/use-current-workspace";

export const Route = createFileRoute("/(onboarding)/onboarding")({
  component: RouteComponent,
});

function RouteComponent() {
  const { currentWorkspace } = useCurrentWorkspace();

  if (!currentWorkspace) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background p-6">
        <Skeleton className="h-64 w-full max-w-xl" />
      </div>
    );
  }

  // The wizard configures the workspace (posting slots, first post, invites),
  // so an editor or viewer who lands here — by an old link, or by switching
  // into a workspace still mid-setup — is sent to the app instead of into a
  // wizard whose steps their role cannot complete.
  if (currentWorkspace.role !== "owner" && currentWorkspace.role !== "admin") {
    return <Navigate to="/queue" replace />;
  }

  return <OnboardingWizard workspace={currentWorkspace} />;
}
